import { Component, PLATFORM_ID, Inject, NgZone } from '@angular/core';
// import { isPlatformBrowser } from '@angular/common';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { map, delay, withLatestFrom } from 'rxjs/operators';
import { LocalizationDataService } from './services/data/localization-data.service';
import { SubscriptionService } from './services/subscription.service';
import { Router } from '@angular/router';
import { ModulesDataService } from './services/data/modules-data.service';
// import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  // For Progressbar
  loaders = this.loader.progress$.pipe(
    delay(1000),
    withLatestFrom(this.loader.progress$),
    map(v => v[1]),
  );
  
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private loader: LoadingBarService, 
    private localizationDataService: LocalizationDataService, 
    private subscriptionService: SubscriptionService,
    private router: Router,
    private ngZone: NgZone,
    private modulesDataService: ModulesDataService) {
      this.localizationDataService.getLocalizations();
  }

  ngOnInit(): void {
    this.subscriptionService.checkSubscription();

    this.localizationDataService.currentLanguage$.subscribe((currentLang: any) => {
      if (currentLang) {
        this.updateMenuTranslations(currentLang.code);
      }
    });
  }

  updateMenuTranslations(currentLang: string): void {
    const modules = this.modulesDataService.getLoadedModules() || []; // Ensure modules is an array

    const translateMenuItems = (items: any[]): any[] => {
        return items.map(item => ({
            ...item,
            name: item.translations?.[currentLang] || item.name, // Use translation or fallback
            children: item.children?.length ? translateMenuItems(item.children) : [] // Recursively update children safely
        }));
    };

    console.log(translateMenuItems(modules));

    this.modulesDataService.saveLoadedModules(translateMenuItems(modules));
  }
}
